import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { machinesApi } from '@/api/client';
import { NodeTable } from './NodeTable';

// ---- Global Node Inventory ----

export function MachineInventory() {
  const { data: machines, isLoading, error } = useQuery({
    queryKey: ['machines'],
    queryFn: () => machinesApi.list(),
    refetchInterval: 5_000,
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/sites"
            className="text-silver-muted hover:text-silver-bright transition-colors"
          >
            <ArrowLeft size={20} />
          </Link>
          <div>
            <h2 className="text-2xl font-bold text-silver-bright">Node Inventory</h2>
            <p className="text-sm text-silver-muted mt-1">
              All nodes across all sites
            </p>
          </div>
        </div>
        {/* No "Register Node" (#804/#835): a hand-registered row has no
            SideroLink node UUID, so the box's own enrollment never matches it
            — it creates a second row — and the orphan still counts toward the
            site's control-plane allocation. Boxes join a site by booting its
            install image (site Overview), or netboot where the `netboot`
            feature flag is on (#954). */}
      </div>

      {isLoading && (
        <div className="text-center py-12 text-silver-muted text-sm">Loading nodes...</div>
      )}
      {error && !machines && (
        <div className="text-center py-12 text-status-error text-sm">Failed to load nodes</div>
      )}
      {machines && (
        <div className="bg-surface border border-surface-elevated rounded-xl">
          <NodeTable machines={machines} />
        </div>
      )}
    </div>
  );
}
